import styled from "styled-components";
import ButtonLink from "../buttonLink";

export const ToggleLink = styled(ButtonLink)`
  margin-left: 5px;
`;
